import React from "react";
import { motion } from "framer-motion";

function Experience() {
  return (
    <motion.div
      className="md:h-screen md:mb-0 mb-[200px]"
      id="experience"
      initial={{ x: "-100vw", opacity: 0.1 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ type: "spring", delay: 0.5, stiffness: 120 }}
    >
      <div className="flex items-center gap-4 justify-center md:justify-start">
        <div className="w-[10%] h-0.5 bg-[#ccd6f6] rounded-full"></div>
        <h3 className="text-center md:text-left font-bold text-2xl md:text-4xl mb-[10px] md:mb-[30px]">
          Experience
        </h3>
        <div className="w-[10%] h-0.5 bg-[#ccd6f6] rounded-full"></div>
      </div>
      {/* <p className="text-justify md:w-[60%] px-[50px] md:px-0 md:mx-0 md:text-start text-xs md:text-base">
        As a junior frontend developer my experience is limited as I have not
        yet worked in a professional capacity. I am currently looking for
        internship/junior roles to fill this blank.
      </p> */}
      <ul className="md:w-[40%] ">
        <li>
          <h1 className="font-bold text-2xl">STABLE BORROW</h1>
          <span className="flex items-center justify-between">
            <h4>Frontend Developer </h4>
            <h4>
              <i>2022-till date</i>
            </h4>
          </span>
          <p className="mt-4">
            As a frontend developer at Stable borrow, I am tasked to implement
            Figma designs to functional frontend codes. Review old frontend
            codes and make updates inline with the new direction.
          </p>
        </li>
      </ul>
    </motion.div>
  );
}

export default Experience;
